/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { Card, Icons } from '../../../../bphComponents/bundle';
import COLORS from '../../../styles/Colors';
import FlexRow from '../../../components/FlexRow';
import { FlagToggleHorizontal } from '../../../components/FlagToggle';
import DeleteModal from '../../../components/modal/DeleteModal';

interface Props {
  onDelete?(): void;
  isFlagged?: boolean;
  onToggleFlag(): void;
  altLeftContent?: any;
  primaryButtonPhrase?: any;
}

const HEAttributeFooter: React.FC<Props> = (props) => {
  const { onDelete, onToggleFlag, isFlagged, altLeftContent, primaryButtonPhrase } = props;
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);

  const showFlagged = !!onToggleFlag;

  return (
    <Card.ExternalContent>
      <FlexRow>
        <div>
          {
            altLeftContent
            ? altLeftContent
            : showFlagged
            ? <FlagToggleHorizontal isFlagged={isFlagged} onClick={onToggleFlag} colorTheme="gsMedDark" />
            : null
          }
        </div>

        {
          onDelete
          ? (
            <div
              className="is-clickable"
              onClick={() => {
                setShowDeleteModal(true);
              }}
            >
              <Icons.IconTrash.Medium color={COLORS.gsMiddle} />
            </div>
          ) : <div />
        }
      </FlexRow>

      <DeleteModal
        isVisible={showDeleteModal}
        primaryButtonPhrase={primaryButtonPhrase}
        onConfirmAction={() => {
          setShowDeleteModal(false);
          onDelete();
        }}
        onCancelAction={() => {
          setShowDeleteModal(false);
        }}
      />
    </Card.ExternalContent>
  );
};

export default HEAttributeFooter;
